import React from 'react';
import SEO from './SEO';
import ConsultancyBanner from './ConsultancyBanner';
import PinkInfoSection from './PinkInfoSection';
import PuttingPeopleFirstSection from './PuttingPeopleFirstSection';

const DataConsultancyPage = () => {
  return (
    <div>
      <SEO
        title="Data Consultancy – Lloyd James Media"
        description="Professional data consultancy services to help your business make informed decisions. Expert data analysis, management, and strategic insights for business growth."
        keywords="data consultancy, data analysis, business intelligence, data management, data strategy, Lloyd James"
        canonical="/data-consultancy"
      />
      {/* Banner Section */}
      <ConsultancyBanner />
      
      {/* Pink Info Section */}
      <PinkInfoSection />
      
      {/* Putting People First Section (includes Simple Banner) */}
      <PuttingPeopleFirstSection />
    </div>
  );
};

export default DataConsultancyPage;